module.exports = __webpack_public_path__ + "static/media/book-demo-illustration.d8fb6bb3.svg";